import RegistrationInfoResult from './RegistrationInfoResult';

export default RegistrationInfoResult;
